import { Button, Typography } from "@material-tailwind/react";
import { retryLogin } from "./login";

export default function LoginProblemPage() {
  const fromBackend = new URLSearchParams(window.location.search).has("error");

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-4 text-center">
      <img src="/edepto-logo-trans.png" alt="Edepto" className="h-10 bg-gray-500 p-2 rounded" />
      <Typography variant="h4">Inloggningen misslyckades</Typography>
      <Typography className="max-w-md text-gray-600">
        {fromBackend
          ? "Google-inloggningen kunde inte slutföras, eller så saknar kontot behörighet till Recruiter."
          : "Du skickades till Google men blev inte inloggad när du kom tillbaka."}{" "}
        Försök igen. Om det fortsätter, prova att rensa cookies för recruiter.edepto.se.
      </Typography>
      <Button onClick={retryLogin}>Logga in med Google</Button>
    </div>
  );
}
